// extracted by mini-css-extract-plugin
export default {"container":"Services_container__EYZYQ","root":"Services_root__ha5ce"};